import React from "react";
import { Col, Row } from "reactstrap";
import { withTranslation } from "react-i18next";
import { get } from "lodash";
import PropTypes from "prop-types";

import Modal from "Components/Common/Modal";
import Backdrop from "Components/Common/Backdrop";

import { useGetOtherApplicationMeterDetailsQuery } from "apis/otherApplicationDetails";

const fields = [
  {
    name: "Serial Number",
    key: "meter.srNo",
    isRequired: true,
  },
  {
    name: "Make",
    key: "meter.make",
    isRequired: true,
  },
  {
    name: "Model Number",
    key: "meter.modelNumber",
    isRequired: true,
  },
];
const ViewOtherUtilityMeterInfo = ({ meterId, handleClose, t }) => {
  const { data: { data: meterData = {} } = {}, isLoading } =
    useGetOtherApplicationMeterDetailsQuery(meterId);

  if (isLoading) {
    return <Backdrop open />;
  }
  return (
    <Modal
      isOpen
      title="Meter Information"
      maxWidth="md"
      handleClose={handleClose}
    >
      <Row className="d-flex mb-2 mt-2">
        {fields.map(({ isVisible, name, key, isRequired, renderField }) => {
          const value = get(meterData, key, "");
          if (typeof isVisible !== "boolean" || isVisible) {
            return (
              <Col key={key} lg={6} className="mb-1">
                <Row>
                  <Col md={5}>{t(name)}:</Col>
                  <Col
                    md={7}
                    className="fw-semibold"
                    style={{ wordBreak: "break-word" }}
                  >
                    {renderField
                      ? renderField(value)
                      : get(meterData, key, null) ?? (isRequired ? "-" : "N/A")}
                  </Col>
                </Row>
              </Col>
            );
          }
        })}
      </Row>
    </Modal>
  );
};

ViewOtherUtilityMeterInfo.propTypes = {
  meterId: PropTypes.number,
  handleClose: PropTypes.func,
  t: PropTypes.func,
};

export default withTranslation()(ViewOtherUtilityMeterInfo);
